import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/common/app';
import emojis from 'simple-emoji-map';
import FuzzySet from 'fuzzyset';
const flatten = function (arr, depth) {
  if (depth === void 0) {
    depth = 1;
  }
  return arr.reduce((a, v) => a.concat(depth > 1 && Array.isArray(v) ? flatten(v, depth - 1) : v), []);
};
const shortnames = flatten(Object.values(emojis));
const entries = Object.entries(emojis);
const getEmoji = identifier => entries.find(_ref => {
  let _ref2 = _slicedToArray(_ref, 2),
    value = _ref2[1];
  return value.includes(identifier);
});
const toUnicodeEmoji = codePoint => String.fromCodePoint(...codePoint.split('-').map(e => "0x".concat(e)));
const emojiCache = new Map();
const fuzzySet = new FuzzySet(shortnames);
export const TWEMOJI_VERSION = '16.0.1';
export const DEFAULT_CDN_URL = 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/[twemoji]/72x72/[codepoint].png';
const search = query => {
  const results = fuzzySet.get(query);
  if (!results) return null;
  const _results$ = _slicedToArray(results[0], 2),
    score = _results$[0],
    item = _results$[1];
  return {
    score,
    item
  };
};
export default function emoji(reactionOrIdentifier) {
  if (!reactionOrIdentifier) return {};
  let identifier = reactionOrIdentifier.identifier || reactionOrIdentifier;
  if (emojiCache.has(identifier)) return emojiCache.get(identifier);
  let score;
  if (!shortnames.includes(identifier)) {
    const match = search(identifier);
    identifier = match == null ? void 0 : match.item;
    score = match == null ? void 0 : match.score;
  }
  const emoji = getEmoji(identifier);
  const codePoint = emoji == null ? void 0 : emoji[0];
  const cdnUrl = app.forum.attribute('fofReactionsCdnUrl') || DEFAULT_CDN_URL;
  const output = codePoint ? {
    identifier,
    score,
    uc: toUnicodeEmoji(codePoint),
    url: cdnUrl.replace('[twemoji]', TWEMOJI_VERSION).replace('[codepoint]', codePoint.toLowerCase()),
    type: 'emoji'
  } : {};
  emojiCache.set(reactionOrIdentifier, output);
  return output || {};
}
flarum.reg.add('fof-reactions', 'common/util/emoji', emoji);